import { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../components/AuthContextComponent";
import {
  forgetPassword,
  GenerateOtp,
  getCurrencies,
  getPartners,
  validateOtp,
} from "../api/FetchAPI";
import {
  FIleUpload,
  Currency,
  partners,
  GenerateOTP,
  BulkValidationInterface,
  IMoneyExchangeInterface,
  SecurityQuestionRequestArray,
  IPay2HomeInterface,
} from "../lib/interfaces/index";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  SomethingAlert,
  stopLoading,
  successAlert,
} from "../promptMessages/PromptMessages";
import { ALERTMSG, ALERTICON, STATUS, ROUTES } from "../lib/enums/index";
import { xlsxConvertToJSON } from "../components/fileUploadComponent/xlsxFileUploadComponent";
import { getFileExtension } from "../components/fileUploadComponent/getFileExtension";
import useHeadComponent from "./HeaderHook";
import { apiContext } from "../lib/config/EncryptAPIContext";
import { useCustomAccount } from "../components/CustomAccountContext";
import { FetchErr } from "../lib/helpers/UnhandledError";

import {
  constructPayload,
  handleConversionError,
  handleValidationResponse,
  isSupportedFileType,
  processFileSource,
} from "../lib/helpers/FileConvertion";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const useManualUpload = () => {
  const { username, userInfo, internalPartnerName, setPartnerName } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // Data in the Table
  const [jsonData, setJsonData] = useState<
    FIleUpload[] | IMoneyExchangeInterface[] | IPay2HomeInterface[]
  >([]);
  const [newJsonData, setNewJsonData] = useState<BulkValidationInterface[]>([]);
  const [totalCharges, setTotalCharges] = useState<number>(0);
  const [totalPrincipalAmount, setTotalPrincipalAmount] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  //currencies
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState<string>("");
  //partners
  const [partners, setPartners] = useState<partners[] | null>(null);
  const [selectedPartner, setSelectedPartner] = useState<number>();
  const [selectedPartnerName, setSelectedPartnerName] = useState("");
  // disable button
  const [clicked, setClicked] = useState(false);
  // Bulk Send Validation success
  const [isValid, setIsValid] = useState(false);
  const [uploading, setUploading] = useState(false);
  // store bulk data after validation
  const [requestData, setRequestData] = useState<any>(null);
  const [isConverting, setIsConverting] = useState(false);
  const [openOTP, setOpenOTP] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [otpTimer, setOtpTimer] = useState<number>(0);
  const [time, setTime] = useState(0);
  const [otpResponse, setOtpResponse] = useState<GenerateOTP>();
  const [upload, setUpload] = useState(false);
  const [requiredCurrency, setRequiredCurrency] = useState(false);
  const [requiredPartner, setRequiredPartner] = useState(false);

  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);
  const [redirectModal, setRedirectModal] = useState(false);

  const { partnerBalance } = useHeadComponent(selectedPartner);

  const requestPayload: any = {
    userId: username,
  };
  const { customAccount } = useCustomAccount();
  const customColor =
    customAccount?.customAccountInfo[0].themeCode.toLowerCase();
  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";

  const fetchCurrentUserQuestion = async () => {
    const response: any = await forgetPassword(username);

    const { respCode, respMsg, questionInfo } = response;

    if (respCode === 2000) {
      if (questionInfo === null || questionInfo < 2) {
        setCurrentQuestions(null);

        setRedirectModal(true);
      } else {
        setCurrentQuestions(questionInfo);
      }
    } else {
      showAlert(
        ALERTMSG.SOMEWENTWRONG,
        `${respMsg} (${respCode})`,
        "error",
        customColor,
        themeBackground,
        themeTextColor,
      );
    }
  };

  // for fetching currency
  const fetchCurrencies = async () => {
    try {
      const currencies = await getCurrencies();
      setCurrencies(currencies);
    } catch (error: any) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  //fetch partners list if the user is "INTERNAL"
  const fetchPartners = async () => {
    try {
      const partners1 = await getPartners(requestPayload);
      setPartners(partners1);
    } catch (error: any) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  useEffect(() => {
    if (otpResponse) {
      setOtpTimer(parseFloat(otpResponse.seconds));
    }
  }, [otpResponse]);

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
    setJsonData([]);
    setUpload(false);

    if (!file) return;

    const fileExtension = getFileExtension(file.name);

    if (!isSupportedFileType(fileExtension || "")) {
      setIsConverting(false);
      showAlert(
        ALERTMSG.INVFILE,
        "This file type is not supported.",
        "error",
        customColor,
        themeBackground,
        themeTextColor,
      );
      event.target.value = "";
      return;
    }

    setIsConverting(true);
    const partnerName =
      userInfo?.category === STATUS.INTERNAL
        ? internalPartnerName
        : userInfo?.partnersName;
    xlsxConvertToJSON(
      file,
      fileExtension || "",
      async (
        json,
        respCode,
        respMsg,
        totalPrincipal,
        batchNo,
        fileSource,
        fileVersion,
      ) => {
        setJsonData(json);

        const sendDetails = processFileSource(
          fileSource || "",
          json,
          selectedCurrency,
        );

        const partnersId =
          userInfo?.category === STATUS.INTERNAL
            ? selectedPartner?.toString() || ""
            : userInfo?.partnersId.toString() || "";

        const data = constructPayload(
          sendDetails,
          userInfo,
          username,
          batchNo || "",
          totalPrincipal || 0,
          fileSource || "",
          partnersId,
          fileVersion || "",
        );

        try {
          const response = await apiContext.post(`/BulkValidation`, data);

          handleValidationResponse(
            response,
            batchNo || "",
            partnersId,
            userInfo,
            username,
            {
              setNewJsonData,
              setTotal,
              setTotalCharges,
              setTotalPrincipalAmount,
              setUpload,
              setIsValid,
              setRequestData,
              setUploading,
              findPartnerNameById,
              successAlert,
              SomethingAlert,
            },
            {
              themeBackground,
              customColor,
              themeTextColor,
            },
          );
        } catch (error: any) {
          // FetchErr(error, themeBackground, customColor, themeTextColor);
          handleHttpError(error, customColor);
        }

        setClicked(true);
        setIsConverting(false);
      },
      (error: any) => {
        handleConversionError(error, setIsConverting, {
          themeBackground,
          customColor,
          themeTextColor,
        });
      },
      partnerName,
    );

    event.target.value = "";
  };

  // browse button
  const handleButtonClick = () => {
    if (userInfo?.category === STATUS.EXTERNAL && !selectedCurrency) {
      return setRequiredCurrency(true);
    } else if (
      userInfo?.category === STATUS.INTERNAL &&
      !selectedPartner &&
      !selectedCurrency
    ) {
      setRequiredCurrency(true);
      setRequiredPartner(true);
      return;
    } else if (userInfo?.category === STATUS.INTERNAL && !selectedPartner) {
      return setRequiredPartner(true);
    } else if (userInfo?.category === STATUS.INTERNAL && !selectedCurrency) {
      return setRequiredCurrency(true);
    }

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSubmit = async (toggle: any = true) => {
    try {
      if (!toggle) {
        setOpenOTP(false);
        return;
      }
      if (isValid) {
        const confirmed = await confirmationMsg(
          "Submit?",
          "",
          themeBackground,
          themeTextColor,
          customColor,
        );

        if (confirmed) {
          generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);
          const res: any = await GenerateOtp(username, "TRANSACTION");
          //added condition to check if res is 2000
          if (res.respCode === 2000) {
            setTime(res.seconds);

            setTimeout(async () => {
              stopLoading();

              setOpenOTP(true);
            }, 2000);
          } else {
            stopLoading();

            showAlert(
              ALERTMSG.SOMEWENTWRONG,
              res.respMsg || " ",
              ALERTICON.ERR,
              customColor,
              themeBackground,
              themeTextColor,
            );
            return;
          }
        } else {
        }
      }
    } catch (error) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  const OTPSubmit = async (
    otp: string,
    data: any,
    setOpenOTPLocal: any,
    restFunc: any,
    setOTP: any,
  ) => {
    try {
      generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);

      const validOTP: any = await validateOtp(username, "TRANSACTION", otp);
      const { expired, respCode, valid, respMsg } = validOTP;

      if (respCode === 2000 && valid && !expired) {
        setOpenOTPLocal(false);

        const response = await apiContext.post(`/BulkSend`, {
          payload: {
            ...data.payload,
            oneTimePin: otp,
          },
        });

        stopLoading();

        const { respCode, respMsg, totalAmount, batchNumber } = response.data;

        if (respCode === 2000) {
          stopLoading();

          const resolvedPartnerId = data?.payload?.partnersId
            ? Number(data.payload.partnersId)
            : undefined;
          partnerBalance(resolvedPartnerId);

          setPartnerName("");
          setUpload(false);

          showAlert(
            ALERTMSG.SENTSUCCESS,
            respMsg,
            ALERTICON.SUCCESS,
            customColor,
            themeBackground,
            themeTextColor,
          );

          restFunc();
        } else {
          stopLoading();
          setUpload(false);
          showAlert(
            ALERTMSG.SENTFAILED,
            respMsg,
            ALERTICON.ERR,
            customColor,
            themeBackground,
            themeTextColor,
          );
          restFunc();
        }
        handleResponse(respCode, respMsg);
      } else {
        stopLoading();
        setOTP(Array(6).fill(""));
        showAlert(
          ALERTMSG.SENTFAILED,
          respMsg || " ",
          ALERTICON.ERR,
          customColor,
          themeBackground,
          themeTextColor,
        );
      }
    } catch (error) {
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  const handleResponse = (respCode: number, respMsg: string) => {
    if (respCode === 2000) {
      showAlert(
        ALERTMSG.SENTSUCCESS,
        respMsg,
        ALERTICON.SUCCESS,
        customColor,
        themeBackground,
        themeTextColor,
      );
      resetFormState();
    } else {
      showAlert(
        ALERTMSG.SENTFAILED,
        respMsg,
        ALERTICON.ERR,
        customColor,
        themeBackground,
        themeTextColor,
      );
      resetFormState();
    }
  };

  const resetFormState = () => {
    setSelectedFile(null);
    setTotal(0);
    setTotalCharges(0);
    setTotalPrincipalAmount(0);
    setNewJsonData([]);
    setUpload(false);
  };

  //selected partner
  const handlePartnerChange = (value: number) => {
    if (requiredPartner) {
      setRequiredPartner(false);
    }
    if (upload) {
      setUpload(false);
      setPartnerName("");
    }
    setSelectedPartner(value);
  };

  const findPartnerNameById = (id: number) => {
    if (Array.isArray(partners)) {
      // Check if partners is an array
      const partner = partners.find((p) => p.id === id);
      setPartnerName(partner?.name || "");
    } else {
      console.error("partners is not an array", partners);
    }
  };

  //selected currency
  const handleCurrencyChange = (value: string) => {
    setSelectedCurrency(value);
    if (requiredCurrency) {
      setRequiredCurrency(false);
    }
  };

  const generateotp = async (username: string, type: string) => {
    const response: any = await GenerateOtp(username, type);

    return response;
  };

  const Validateotp = async (
    username: string,
    type: string,
    oneTimePin: string,
  ) => {
    try {
      generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);
      const response: any = await validateOtp(username, type, oneTimePin);
      const { respCode, valid, expired, respMsg } = response;
      // setValidateOTP(response); // Update state with the response

      // Check response directly instead of relying on state
      if (respCode === 2000 && valid && !expired) {
        setTimeout(() => {
          stopLoading();
          navigate(ROUTES.MANUALUPLOAD);
        }, 500);
      } else {
        setTimeout(() => {
          stopLoading();
          showAlert(
            ALERTMSG.SOMEWENTWRONG,
            respMsg || " ",
            ALERTICON.ERR,
            customColor,
            themeBackground,
            themeTextColor,
          );
        }, 1000);
      }
    } catch (error) {
      stopLoading();

      // showAlert(
      //   ALERTMSG.SENTFAILED,
      //   "An error occurred while processing your request.",
      //   ALERTICON.ERR,
      //   customColor,
      //   themeBackground,
      //   themeTextColor
      // );
      handleHttpError(error, customColor);
    }
  };

  return {
    selectedFile,
    jsonData,
    newJsonData,
    totalCharges,
    totalPrincipalAmount,
    total,
    currencies,
    fileInputRef,
    selectedCurrency,
    partners,
    selectedPartner,
    clicked,
    isValid,
    uploading,
    requestData,
    isConverting,
    openOTP,
    otpTimer,
    otpResponse,
    time,
    upload,
    requiredCurrency,
    requiredPartner,
    redirectModal,
    selectedPartnerName,
    themeBackground,
    themeTextColor,
    fetchCurrentUserQuestion,
    setRequiredPartner,
    handleFileChange,
    handleButtonClick,
    handleSubmit,
    handlePartnerChange,
    handleCurrencyChange,
    OTPSubmit,
    handleResponse,
    setSelectedFile,
    setTotal,
    setTotalCharges,
    setTotalPrincipalAmount,
    setNewJsonData,
    setOpenOTP,
    generateotp,
    Validateotp,
    setOtpTimer,
    resetFormState,
    fetchCurrencies,
    fetchPartners,
  };
};
export default useManualUpload;
